<div class="profile-page">
    <div class="wrapper">
        <div class="page-header page-header" filter-color="red">
            <div class="page-header-image path" data-parallax="true">
            </div>
            <div class="container">
                <div class="content-center">
                    <div class="cc-profile-image">
                        <a href="#">
                            <img src="assets/images/aunt_tracie.jpeg" class="rounded-circle" alt="Image" style="height: 250px; width:250px"/>
                        </a>
                    </div>
                    <h3 class="h3 title">Hi, I'm Tracie Sarkar</h3>
                    <p class="category text-white">Find peace within yourself.</p>
                                    </div>
            </div>

        </div>
    </div>
</div>